import { Member, MembersResponse, convertMembersAsync } from '@nextforce/api'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'chat/shared/queries/keys'
import { useMemberListProgressContext } from '../progress_context'
import { filterMembers } from '../recipients/util'

export function useRecipients(companyId?: string) {
  const { server } = useServer()
  const { setProgress } = useMemberListProgressContext()

  const key = keys.recipients(companyId)

  return useQuery<Member[]>({
    queryKey: key,
    queryFn: fetchRecipients,
    refetchOnMount: true,
  })

  async function fetchRecipients(): Promise<Member[]> {
    const response = await server.get<MembersResponse.Member[]>(
      `/v2/chat/recipients${companyId ? `?company_id=${companyId}` : ''}`
    )
    const members = await convertMembersAsync(response, setProgress)
    return members
  }
}

export function useSearchRecipients(searchTerm?: string, companyId?: string) {
  const recipientsQuery = useRecipients(companyId)

  const searchRecipientsQuery = useQuery<Member[]>({
    queryKey: keys.searchRecipients(searchTerm, companyId),
    queryFn: fetchFilteredRecipients,
    enabled: !recipientsQuery.isLoading,
    refetchOnMount: true,
    placeholderData: keepPreviousData,
  })
  return {
    ...searchRecipientsQuery,
    isLoading: recipientsQuery.isLoading,
  }

  function fetchFilteredRecipients() {
    if (searchTerm) {
      return filterMembers(recipientsQuery.data, searchTerm)
    }
    return recipientsQuery.data ?? []
  }
}
